<template>

  <body>
    <header-component></header-component>
    <main :style="{'flex-direction': $screen.breakpoint !=='sm' ? 'row' : 'column', 'overflow-y': $screen.breakpoint !== 'lg' ? 'scroll' : 'hidden'}">
      <nav-scroller-component></nav-scroller-component>
      <info-component></info-component>
    </main>
  </body>

</template>

<script type="text/javascript">

import Header from './Header';
import Nav from './Nav';
import Info from './Info';

export default {
  data(){
    return {

    }
  },
  components: {
    'header-component': Header,
    'nav-scroller-component': Nav,
    'info-component': Info
  }
}

</script>

<style scoped>

body {
  color: rgb(110, 110, 111);
  font-family: Roboto, sans-sans-serif;
  width: 100vw;
  height: 100vh;
  background: rgb(230, 230, 230);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
}

main {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* flex-wrap: wrap; */
  height: calc(100% - 85px);
  overflow-x: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/api/APIDocs.vue